import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";

import { trackPromise } from "react-promise-tracker";

import { Input, message } from "antd";
import { saveAs } from "file-saver";

import { listarPastasPorFiltro } from "../../services/http/pastaService";
import {
  deletarNotificacoes,
  listarNotificacoes,
  listarTitulosNotificacoes,
  marcarComoLida,
} from "../../services/http/notificacoesService";
import services from "../../services";

import DraftsIcon from "@mui/icons-material/Drafts";
import MarkunreadIcon from "@mui/icons-material/Markunread";
import { IoIosNotificationsOutline } from "react-icons/io";

import { exportarRelatorioAtividadesRecentes } from "../../services/http/atividadeRecenteService";
import { CiUser } from "react-icons/ci";

import { logout } from "../../services/api";
import lang from "../../assets/idioma/idiomas";
import { SearchOutlined, BellOutlined } from "@ant-design/icons";
import { Badge, AutoComplete, Menu, Dropdown } from "antd";
import { HubConnectionBuilder } from "@microsoft/signalr";
import IcNotificacao from "../../assets/icons/IconNotificacaoHeader.svg";
import IconeArquivos from "../IconeArquivos";

import logoEmpresa from "../../assets/logoEmpresa.png";
import infoPastaSvg from "../../assets/icons/infoPasta.svg";
import logoRedondo from "../../assets/logoRedonto.png";
import "./styles.scss";
import globals from "../../globlas";
import ExpandCircleDownIcon from "@mui/icons-material/ExpandCircleDown";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

const REACT_APP_MIDIA_COOPERADA_LINK = globals.REACT_APP_MIDIA_COOPERADA_LINK;

const { Option } = AutoComplete;

const Header = ({
  style,
  className,
  setBuscarPorNome,
  mostrarPesquisar,
  showInfo,
  buscarPorNome,
  local,
  setLocal,
  mostrarPesquisaAvancada,
  setMostrarPesquisaAvancada,
  notificacaoVisualizada,
  setNovaEdit,
  novaEdit,
}) => {
  const history = useHistory();
  const { IdUser, IsAdmin } = services.storage.getUser();
  const [resultado, setResultado] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  const [defaultValue, setDetaultValue] = useState(buscarPorNome);
  const [nomes, setNomes] = useState([]);
  const [mostrarDetalheNotificacao, setMostrarDetalheNotificacao] = useState(
    []
  );
  const [excluirNotificacao, setExcluirNotificacao] = useState("");
  const [detalheNotificacao, setDetalheNotificacao] = useState("");
  const [qtdNotificacoes, setQtdNotificacoes] = useState(0);

  const [listaNotificacoes, setlistaNotificacoes] = useState([
    // {
    //   link: "",
    //   visualizado: false,
    //   verDetalhe: false,
    //   titulo: "Google Teste de Tamanho de Nome",
    //   tempo: "2023-11-16T20:38",
    //   mensagem:
    //     " since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
    // },
    // {
    //   link: "www.google.com",
    //   visualizado: false,
    //   verDetalhe: false,
    //   titulo: "Google",
    //   tempo: "2023-11-16T17:38",
    //   mensagem:
    //     " since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
    // },
    // {
    //   link: "www.google.com",
    //   visualizado: false,
    //   verDetalhe: false,
    //   titulo: "Google",
    //   tempo: "2023-11-08T20:40",
    //   mensagem:
    //     " since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
    // },
    // {
    //   link: "www.google.com",
    //   visualizado: false,
    //   verDetalhe: false,
    //   titulo: "Google Google Google",
    //   tempo: "2023-11-15T16:06",
    //   mensagem:
    //     " since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
    // },
  ]);

  const [notificacoesAbertas, setNotificacoesAbertas] = useState(false);

  const fnMarcarComoLida = (id) => {
    setDois(false);
    trackPromise(
      marcarComoLida(id)
        .then((res) => {
          listaNotificacoesSino();
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };
  const fnDeletarNotificacoes = (id) => {
    setDois(false);
    trackPromise(
      deletarNotificacoes(id)
        .then((res) => {
          listaNotificacoesSino();
          setExcluirNotificacao("");
          message.success(lang.Notificacao_deletada_com_sucesso);
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const exelRelatorioAtividadesRecentes = () => {
    trackPromise(
      exportarRelatorioAtividadesRecentes().then((res) => {
        if (res.data) {
          saveAs(res.data, "relatorio-atividade.xlsx");
          return;
        } else {
          console.warning("Não foi possível gerar exel");
        }
      })
    ).catch((error) => {
      console.error("Não foi possível gerar exel");
    });
  };

  const pastas = () => {
    trackPromise(
      listarPastasPorFiltro()
        .then((res) => {
          if (!res.fail && res.data) {
            let array = [];

            res.data.lista.forEach((item) => {
              array.push(item.nomePasta);
            });

            setNomes(array);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const sair = () => {
    services.storage.clear();
    //logout();
    window.open(REACT_APP_MIDIA_COOPERADA_LINK, "_self");
  };

  function transformaData(inputData) {
    const dataEnvio = new Date(inputData);
    // Obtém a data e hora atuais com o ajuste de fuso horário
    const agora = new Date(
      new Date().toLocaleString("en-US", { timeZone: "UTC" })
    );
    const diferencaTempo = agora - dataEnvio;

    if (diferencaTempo < 23 * 60 * 60 * 1000) {
      return `${tempoPassado(diferencaTempo)}`;
    } else if (diferencaTempo < 24 * 60 * 60 * 1000) {
      return `${formatarHora(dataEnvio)}`;
    } else if (diferencaTempo < 7 * 24 * 60 * 60 * 1000) {
      return `${Math.floor(diferencaTempo / (24 * 60 * 60 * 1000))} d`;
    } else {
      return `${formatarDataHora(dataEnvio)}`;
    }
  }

  function tempoPassado(diferenca) {
    const minutos = Math.floor(diferenca / (60 * 1000));

    if (minutos < 60) {
      return `${minutos} min`;
    } else if (minutos < 120) {
      return "1h";
    } else {
      const horas = Math.floor(minutos / 60);
      return `${horas} h`;
    }
  }

  function formatarHora(data) {
    return `${("0" + (data.getHours() - 3)).slice(-2)}:${(
      "0" + data.getMinutes()
    ).slice(-2)}`;
  }

  function formatarDataHora(data) {
    return `${("0" + data.getDate()).slice(-2)}/${(
      "0" +
      (data.getMonth() + 1)
    ).slice(-2)} - ${formatarHora(data)}`;
  }

  const menu = (
    <div className="menu">
      <Menu className="user-menu">
        <Menu.Item key="0" onClick={() => history.push("/perfil-usuario")}>
          {lang.Perfil}
        </Menu.Item>
        <Menu.Item key="1" onClick={sair}>
          {lang.Sair}
        </Menu.Item>
      </Menu>
    </div>
  );
  const [dois, setDois] = useState(null);
  const linkNot = (link) => {
    window.open(link, "_blank");
  };

  const listNotificacoes = () => {
    return (
      <div className="menu">
        {listaNotificacoes?.length != 0 && listaNotificacoes && (
          <Menu className="menuExtarnoNotificacao">
            {listaNotificacoes &&
              listaNotificacoes.map((notificacao, index) =>
                notificacao.id === excluirNotificacao ? (
                  <Menu.Item
                    style={{
                      marginBottom:
                        listaNotificacoes.length === index + 1 ? 0 : 10,
                      cursor: "default",
                      minHeight: 94,
                      maxHeight: 94,
                      width: 368,
                    }}
                    key={index}
                    className={"negritoNotificacao"}
                  >
                    <div>
                      <div className="my-2">
                        <div
                          style={{
                            color: "#a0a0a0",
                            textAlign: "right",
                            margin: "-5px 15px -5px 0",
                            fontSize: 12,
                          }}
                        ></div>
                        <div className="d-flex justify-content-center  ">
                          <div
                            style={{
                              fontWeight: 900,
                            }}
                          >
                            {lang.Deseja_realmente_excluir_a_notificacao}
                          </div>
                        </div>

                        <div
                          style={{
                            padding: 5,
                            fontWeight: notificacao.visualizado ? 400 : 900,
                          }}
                        >
                          <div className="d-flex justify-content-center w-100 mt-3 ">
                            <button
                              className="btn btn-primary btn-sm mx-3 "
                              onClick={(e) => {
                                e.stopPropagation();
                                setExcluirNotificacao("");
                              }}
                            >
                              {lang.Nao}
                            </button>
                            <button
                              className="btn btn-danger btn-sm mx-3 "
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: "#3f3f3f",
                                border: "none",
                                color: "#ffffff",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                fnDeletarNotificacoes(notificacao.id);
                              }}
                            >
                              {lang.Sim}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Menu.Item>
                ) : (
                  <Menu.Item
                    style={{
                      marginBottom:
                        listaNotificacoes.length === index + 1 ? 0 : 10,
                      minHeight: 94,
                      cursor:
                        notificacao.link == null ||
                        notificacao.link == "" ||
                        notificacao.link == undefined
                          ? "default"
                          : "pointer",
                    }}
                    key={index}
                    onClick={(e) => {
                      if (
                        notificacao.link !== null &&
                        notificacao.link !== "" &&
                        notificacao.link !== undefined
                      ) {
                        linkNot(notificacao.link);
                      }
                    }}
                    className={
                      notificacao.visualizado
                        ? "negritoNotificacao"
                        : " negritoNotificacaoNaoLida"
                    }
                  >
                    <div>
                      <div className="my-2">
                        <div
                          style={{
                            color: "#000000",
                            textAlign: "right",
                            margin: "-5px 15px -5px 0",
                            fontSize: 12,
                          }}
                        >
                          {transformaData(notificacao.dataEnvioUtc)}
                        </div>
                        <div className="d-flex align-items-center justify-content-between ">
                          <div
                            className="d-flex  align-items-center"
                            style={{ maxWidth: 300 }}
                          >
                            {notificacao.visualizado ? (
                              <DraftsIcon
                                style={{ marginRight: 10, color: "#3a3a3a" }}
                              />
                            ) : (
                              <MarkunreadIcon
                                style={{ marginRight: 10, color: "3a3a3a" }}
                              />
                            )}
                            <div
                              className="notificacaoTitulo"
                              style={{
                                fontWeight: notificacao.visualizado ? 400 : 900,
                              }}
                            >
                              {notificacao.titulo}
                            </div>
                          </div>
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                              setExcluirNotificacao(notificacao.id);
                            }}
                          >
                            <HighlightOffIcon
                              style={{ color: "#aaa", margin: "0 10px" }}
                            />
                          </div>
                        </div>
                        <div className="d-flex  ">
                          {notificacao.id === detalheNotificacao ? (
                            <div
                              style={{
                                maxWidth: 300,
                                minWidth: 300,
                                padding: 5,
                                fontWeight: 400,
                              }}
                            >
                              {notificacao.subtitulo}
                            </div>
                          ) : (
                            <div
                              className="notificacaoResumo"
                              style={{
                                fontWeight: 400,
                              }}
                            >
                              {notificacao.subtitulo}
                            </div>
                          )}
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                              setDetalheNotificacao(
                                notificacao.id !== detalheNotificacao
                                  ? notificacao.id
                                  : ""
                              );
                              if (notificacao.visualizado == false) {
                                fnMarcarComoLida(notificacao.id);
                              }

                              const newNotificacoes = [...listaNotificacoes];
                              newNotificacoes[index].verDetalhe =
                                !newNotificacoes[index].verDetalhe;
                              setlistaNotificacoes(newNotificacoes);
                            }}
                          >
                            <div
                              style={{
                                color: "#aaa",
                                margin: "0 10px",
                                transform:
                                  notificacao.id === detalheNotificacao
                                    ? "rotate(180deg)"
                                    : "rotate(0deg)",
                              }}
                            >
                              <ExpandCircleDownIcon />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Menu.Item>
                )
              )}
          </Menu>
        )}
      </div>
    );
  };

  const renderItem = (item) => ({
    value: item.nome,
    label: (
      <>
        <span>
          {item.tipo == 0 ? (
            <img src={infoPastaSvg} style={{ width: "1rem", height: "1rem" }} />
          ) : (
            <IconeArquivos
              style={{ width: "1rem", height: "1rem" }}
              tamanho={"P"}
              tipo={item.extensao}
            />
          )}
        </span>
        <span className="pesquisar-header-lista-nome">{item.nome}</span>
      </>
    ),
  });

  const [pesquisar, setPesquisar] = useState("");

  const handleSearch = (searchText) => {
    setPesquisar(searchText);
  };
  useEffect(() => {
    let timerId;
    if (
      pesquisar &&
      local !== "filho" &&
      local !== "pai" &&
      local != "lixeira"
    ) {
      timerId = setTimeout(() => {
        if (pesquisar) {
          let arrayResultado = [];
          let arrayDataSource = [];

          trackPromise(
            listarPastasPorFiltro(IdUser, 1, 9999, pesquisar).then((res) => {
              if (!res.fail && res.data) {
                res.data.lista.forEach((item) => {
                  if (
                    arrayResultado.findIndex((x) => x.value == item.nome) < 0
                  ) {
                    arrayResultado.push(renderItem(item));
                    arrayDataSource.push(item);
                  }
                });
                setResultado(arrayResultado);
                setDataSource(arrayDataSource);
              }
            })
          );
        }
      }, 800);
    }
    return () => {
      clearTimeout(timerId);
    };
  }, [pesquisar, local]);

  const handleEnterPress = (e) => {
    setBuscarPorNome(e);
    setLocal("filtro");
  };

  const customFind = () => {
    setBuscarPorNome(buscarPorNome);
    setLocal("filtro");
  };

  const handleSelect = (value) => {
    setLocal("filtro");
    const index = dataSource.findIndex((item) => item.nome == value);

    if (index >= 0) {
      const retorno = dataSource[index];

      if (retorno.tipo == 1) {
        showInfo(retorno.id, "arquivo");
      }
    }

    return;
  };

  const [url, setUrl] = useState("");
  const pathname = () => {
    return window.location.pathname;
  };

  useEffect(() => {
    setUrl(pathname());
  }, [pathname]);

  const abrirNotificacoes = () => {
    if (
      listaNotificacoes?.length == 0 ||
      listaNotificacoes == undefined ||
      listaNotificacoes == [] ||
      listaNotificacoes == null
    ) {
      message.warning(lang.Nao_ha_notificacoes);
    } else {
      setNotificacoesAbertas(true);
    }
  };
  const fecharNotificacoes = () => {
    setNotificacoesAbertas(false);
  };
  const listaNotificacoesSino = () => {
    trackPromise(
      listarTitulosNotificacoes(IdUser)
        .then((res) => {
          if (!res.fail && res.data) {
            setlistaNotificacoes(res.data);
            const naoVisualizadas = res.data.filter(
              (notificacao) => !notificacao.visualizado
            );

            setQtdNotificacoes(naoVisualizadas.length);
          }

          setNovaEdit(false);
        })
        .catch((error) => {
          console.error(error);
          // setlistaNotificacoes([{link:'www.google.com',visualizado:false, titulo:'google'},{link:'www.google.com',visualizado:false, titulo:'google'},{link:'www.google.com',visualizado:false, titulo:'google'},{link:'www.google.com',visualizado:false, titulo:'google'},{link:'www.google.com',visualizado:false, titulo:'google'},{link:'www.google.com',visualizado:false, titulo:'google'}]);
        })
    );
  };

  useEffect(() => {
    listaNotificacoesSino();
  }, []);
  useEffect(() => {
    if (novaEdit == true) {
      listaNotificacoesSino();
    }
  }, [novaEdit]);

  useEffect(() => {
    pastas();
  }, []);

  return (
    <div className={`w-100`}>
      <nav
        className="navbar navbar-expand-lg navbar-dark"
        style={{ backgroundColor: "#000000", color: "white" }}
      >
        <div className="container">
          <a className="navbar-brand logo-header" href="#">
            <img src={logoEmpresa} alt="teste" />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarTogglerDemo02"
            aria-controls="navbarTogglerDemo02"
            aria-expanded="false"
            aria-label="Alterna navegação"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarTogglerDemo02">
            <ul className="navbar-nav mr-auto mt-2 mt-lg-0 ">
              {IsAdmin.toLocaleLowerCase() == "true" && (
                <Link
                  to="/home-banners"
                  className={
                    "nav-item nav-link " +
                    (url == "/home-banners" ? "selecionado" : "")
                  }
                >
                  {lang.Home}
                </Link>
              )}

              <Link
                to="/galeria-midia"
                className={
                  "nav-item nav-link " +
                  (url == "/galeria-midia" ? "selecionado" : "")
                }
              >
                Geely Brand Hub
              </Link>

              {IsAdmin.toLocaleLowerCase() == "true" && (
                <Link
                  to="/cadastros"
                  className={
                    "nav-item nav-link " +
                    (url.startsWith("/cadastros") || url == "/usuario"
                      ? "selecionado"
                      : "")
                  }
                >
                  {lang.Cadastros}
                </Link>
              )}
 

              {IsAdmin.toLocaleLowerCase() == "true" && (
                <Link
                  to="/configuracoes"
                  className={
                    "nav-item nav-link " +
                    (url == "/configuracoes" ? "selecionado" : "")
                  }
                >
                  {lang.Configuracoes}
                </Link>
              )}

              {IsAdmin.toLocaleLowerCase() == "true" && (
                <Link
                  to="/dashboard"
                  className={
                    "nav-item nav-link " +
                    (url == "/dashboard" ? "selecionado" : "")
                  }
                >
                  {lang.Dashboard}
                </Link>
              )}

              {IsAdmin.toLocaleLowerCase() == "true" && (
                <Link
                  to="/log"
                  className={
                    "nav-item nav-link " + (url == "/log" ? "selecionado" : "")
                  }
                >
                  {lang.Log}
                </Link>
              )}
            </ul>
            <div className="pesquisar-content">
              {mostrarPesquisar && (
                <div
                  className="pesquisar-autocomplete"
                  style={{ width: "100%" }}
                >
                  <AutoComplete
                    dropdownClassName="dropdownload-pesquisar-header"
                    onSelect={(e) => handleSelect(e)}
                    className="pesquisar-header"
                    options={resultado}
                    backfill={true}
                    autoClearSearchValue={true}
                    style={{ backgroundColor: "#00000000" }}
                    value={buscarPorNome}
                    onChange={(e) => setBuscarPorNome(e)}
                  >
                    <Input
                      className="pesquisa-input"
                      style={{ backgroundColor: "#00000000",border: "none" }}
                      placeholder={lang.Pesquisar}
                      onPressEnter={(e) => handleEnterPress(e.target.value)}
                      onChange={(e) => handleSearch(e.target.value)}
                    />
                  </AutoComplete>
                  <SearchOutlined
                    onClick={customFind}
                    className="pesquisar-icon-search header-icons"
                  />
                </div>
              )}
              <div className="pesquisar-avatar my-2 my-sm-0">
                <Dropdown
                  className="pesquisar-drodown"
                  overlay={listNotificacoes}
                  trigger={["click"]}
                  onVisibleChange={(visivel) =>
                    visivel ? abrirNotificacoes() : fecharNotificacoes()
                  }
                >
                  <Badge
                    count={qtdNotificacoes}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      color: "#828282",
                    }}
                  >
                    <IoIosNotificationsOutline
                      style={{ color: "#ffffff", fontSize: "34px" }}
                    />
                  </Badge>
                </Dropdown>
                <Dropdown
                  className="pesquisar-drodown"
                  overlay={menu}
                  trigger={["click"]}
                >
                  <a
                    className="ant-dropdown-link"
                    onClick={(e) => e.preventDefault()}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <CiUser style={{ color: "#ffffff", fontSize: "34px" }} />
                  </a>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Header;
